import {
	Header,
	RootContainer,
	SideBar,
	SideBarContainer,
} from '../LayoutClient/container.styles'
import { useDispatch, useSelector } from 'react-redux'
import Footer from '../Footer/footer.component'
import Logo from '../../../src/assets/img/FullLogo_Transparent.png'
import MenuItems from '../LayoutClient/menu-item.component'
import { PUBLIC } from '../../api/base'
import React, { useState, useEffect } from 'react'
import { logoutAction } from '../../redux/auth'
import { useHistory } from 'react-router'
import { logout } from '../../api/auth'
import { chauffeurMenuItems } from './chaffeurSideBarMenuItems'
import ChatSupportWidget from '../ChatSupportWidget/ChatSupportWidget'
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next'
import { MenuItem, Menu } from '@mui/material'
import ReactCountryFlag from "react-country-flag"
import {FaPowerOff} from 'react-icons/fa'
function LayoutChauffeur({ children }) {
	const history = useHistory()
	const dispatch = useDispatch()
	const user = useSelector((state) => state.auth.user)
	const token = useSelector((state) => state.auth.token)
	const refreshToken = useSelector((state) => state.auth.refreshToken)
	const [activeMenuItem, setActiveMenuItem] = useState(null)

	useEffect(() => {
		const path = history.location.pathname

		if (path.includes('/chauffeur/transports')) {
			setActiveMenuItem('mes-transports')
		} else if (path.includes('/chauffeur/historique')) {
			setActiveMenuItem('historique')
		} else if (path.includes('/annulées/chauffeur')) {
			setActiveMenuItem('annulées')
		} else if (path.includes('/chauffeur/account')) {
			setActiveMenuItem('compte')
		}

		// Add more conditions for other routes
	}, [history.location.pathname])
	// Style for icons (adjust size/color as needed)
	const iconStyle = { color: 'white', fontSize: '18px' } // Consistent style

	const handleLogout = async () => {
		try {
			const data = {
				userId: user._id,
				refreshToken,
			}
			await logout(data, token)
			dispatch(logoutAction())
			history.push('/login')
		} catch (error) {
			console.error('Logout error:', error)
			dispatch(logoutAction())
			history.push('/login')
		}
	}
	const { t } = useTranslation()
	const renderMenuItem = (item) => {
		switch (item) {
			case "Mes transports": return t("my_transports")
			case "Historique": return t("history")
			case "Annulées": return t("cancelled_p")
			case "Mon compte": return t("my_account")
			case "Déconnexion": return t("logout")
			default: return
		}
	}

	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
	const savedLanguage = localStorage.getItem('language') ? localStorage.getItem('language') : 'FR';
	const [selectedItem, setSelectedItem] = useState(savedLanguage === 'FR' ? 1 : 2)
	const { i18n } = useTranslation();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleLanguageMenuItemClick = (event, value) => {
		var language = value === 1 ? "FR" : "EN"
		event.stopPropagation();
		setSelectedItem(value);
		localStorage.setItem('language', language);
		i18n.changeLanguage(language.toLowerCase());
		setAnchorEl(null);

	};

	useEffect(() => {
		const checkIfMobile = () => {
			setIsMobile(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);

	useEffect(() => {
		if (isMobileMenuOpen && isMobile) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'unset';
		}
	}, [isMobileMenuOpen, isMobile]);

	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen);
	};
	const handleMenuItemClick = (originalOnClick) => {
		return () => {
			if (originalOnClick) originalOnClick();
			if (isMobile) setIsMobileMenuOpen(false);
		};
	};

	return (
		<RootContainer>
			<Header>
				<div style={{ display: 'flex', alignItems: 'center' }}>

					{isMobile && (

						<button
							onClick={toggleMobileMenu}
							style={{
								background: 'none',
								border: 'none',
								cursor: 'pointer',
								padding: '0.5rem',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								marginRight: '1rem',
								color: "white"
							}}
						>
							<MenuIcon size={24} />
						</button>
					)}

					{!isMobile && <img
						style={{
							width: isMobile ? '8rem' : '12rem',
						}}
						alt="logo"
						src={Logo}
					/>}
				</div>
				<div
					style={{
						background: isMobile ? 'transparent' : '#50F5A9',
						paddingRight: isMobile ? '1rem' : '2rem',
						paddingLeft: isMobile ? '1rem' : '2rem',
						paddingTop: '0.5rem',
						paddingBottom: '0.5rem',
						borderRadius: '0.9rem',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-evenly',
						fontFamily: 'Montserrat',
						color: '#fff',
						fontWeight: 'bold',
						fontSize: '1rem',
						//textTransform: 'uppercase'
					}}
				>

					<span>
						{isMobile ? '' : t("welcome")}
						{user && (
							<>
								{user.first_name} {user.last_name}
							</>
						)}
					</span>

					<span style={{ width: '10px' }} />



					<img
						style={{
							width: '2rem',
							height: '2rem',
							borderRadius: '1rem',
						}}
						alt='user'
						src={
							user && user.logo
								? `${PUBLIC}/${user.logo.name}`
								: 'https://secure.gravatar.com/avatar/6ee7af2da22737fd49ce56adc226d2cb?size=200&d=mp'
						}
					/>
				</div>
			</Header>
			<div
				style={{
					background: 'red',
					height: 'calc(100vh - 7rem)',
					width: '100%',
					display: 'flex',
					flexDirection: 'row',
				}}
			>
				{/* Mobile Overlay */}
				{isMobile && isMobileMenuOpen && (
					<div
						onClick={toggleMobileMenu}
						style={{
							position: 'fixed',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							background: 'rgba(0, 0, 0, 0.5)',
							zIndex: 998,
						}}
					/>
				)}
				<div
					style={{
						position: isMobile ? 'fixed' : 'relative',
						left: isMobile ? (isMobileMenuOpen ? 0 : '-100%') : 0,
						top: isMobile ? 0 : 'auto',
						height: isMobile ? '100vh' : 'auto',
						transition: 'left 0.3s ease-in-out',
						zIndex: 999,
						width: isMobile ? '280px' : 'auto',
						overflowY: 'auto',
					}}
				>
					<SideBar>
						<SideBarContainer>
							{chauffeurMenuItems
								.filter(
									(item) => !item.hideWhen || !item.hideWhen(user)
								)
								.map((item) => (
									<MenuItems
										key={item.id}
										title={renderMenuItem(item.title)}
										onClick={
											item.path
												? handleMenuItemClick(() => history.push(item.path))
												: item.action === 'logout'
													? handleMenuItemClick(handleLogout)
													: undefined
										}
										active={activeMenuItem === item.id}
										icon={item.icon}
									/>
								))}
							<div className='menu-item-container'>
								<div
									className='menu-item'
									onClick={handleMenuOpen}
									id="language-button"
									aria-controls={open ? 'language-menu' : undefined}
									aria-haspopup="true"
									aria-expanded={open ? 'true' : undefined}
								>
									<div className='icon-container'>
										<ReactCountryFlag
											countryCode={selectedItem === 1 ? "FR" : "US"}
											svg
											style={{ width: '24px', height: '24px' }}
										/>
									</div>
									<span className='menu-title'>
										{selectedItem === 1 ? "Français" : "English"}
									</span>
								</div>
							</div>

							<Menu
								id="language-menu"
								anchorEl={anchorEl}
								open={open}
								onClose={handleMenuClose}
								slotProps={{
									list: {
										'aria-labelledby': 'language-button',
									},
								}}
							>
								<MenuItem
									onClick={(event) => handleLanguageMenuItemClick(event, 1)}
									style={{ display: 'flex', gap: 8 }}
								>
									<ReactCountryFlag countryCode="FR" svg />
									Français
								</MenuItem>
								<MenuItem
									onClick={(event) => handleLanguageMenuItemClick(event, 2)}
									style={{ display: 'flex', gap: 8 }}
								>
									<ReactCountryFlag countryCode="US" svg />
									English
								</MenuItem>
							</Menu>
							<MenuItems
										key='logout'
										title={renderMenuItem('Déconnexion')}
										onClick={ handleMenuItemClick(handleLogout)}
										active={activeMenuItem === 'logout'}
										icon={<FaPowerOff style={iconStyle} />}
									/>
						</SideBarContainer>
					</SideBar>
				</div>
				<div
					style={{
						width: '100%',
						background: 'white',
						position: 'relative',
						overflowY:
							user.status === 'suspendu' ? 'hidden' : 'auto',
					}}
				>
					{children}
					{user.status === 'suspendu' && (
						<div
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								right: 0,
								bottom: 0,
								background: 'rgba(0, 0, 0, 0.5)',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<div
								style={{
									width: isMobile ? '90%' : '50%',
									// height: '50%',
									background: 'white',
									borderRadius: 5,
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									justifyContent: 'center',
									padding: '2rem 2rem',
									textAlign: 'center',
								}}
							>
								<span
									style={{
										fontFamily: 'Montserrat',
										fontSize: isMobile ? 18 : 20,
										marginBottom: '2rem',
									}}
								>
									Compte suspendu
								</span>
								<span
									style={{
										fontFamily: 'Montserrat',
									}}
								>
									Votre accès à été limité.
								</span>
							</div>
						</div>
					)}
				</div>
			</div>
			<ChatSupportWidget />
			<Footer />
		</RootContainer>
	)
}

export default LayoutChauffeur
